import _extends from "@babel/runtime/helpers/esm/extends";
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY

import * as React from 'react';
import TaobaoCircleOutlinedSvg from "@ant-design/icons-svg/es/asn/TaobaoCircleOutlined";
import AntdIcon from "../components/AntdIcon";
var TaobaoCircleOutlined = function TaobaoCircleOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: TaobaoCircleOutlinedSvg
  }));
};
if (process.env.NODE_ENV !== 'production') {
  TaobaoCircleOutlined.displayName = 'TaobaoCircleOutlined';
}
export default /*#__PURE__*/React.forwardRef(TaobaoCircleOutlined);